export default __webpack_public_path__ + "static/media/ACO 1.6.3e26dde4.jpg";